import { render, staticRenderFns } from "./BannerMaterial.vue?vue&type=template&id=00c5e500&scoped=true&"
import script from "./BannerMaterial.vue?vue&type=script&lang=js&"
export * from "./BannerMaterial.vue?vue&type=script&lang=js&"
import style0 from "./BannerMaterial.vue?vue&type=style&index=0&id=00c5e500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5e500",
  null
  
)

export default component.exports